import { IIconStyles, ITooltipHostStyles, mergeStyles } from '@fluentui/react';

export const defaultFontColor: string = "#323130";

export const svgIconStyles: React.CSSProperties = {
    color: defaultFontColor,
    lineHeight: 0,
    display: "inline",
    alignSelf: "center"
}

export const smallPadLeft: React.CSSProperties = {
    marginLeft: 3
}

export const flexTooltipHost: ITooltipHostStyles = {
    root: {
        display: "flex"
    }
}

export const fontIconStylesSmall = mergeStyles({
    fontSize: 12
});

export const fontIconStylesMedium = mergeStyles({
    fontSize: 16
});

export const fontIconStyles = mergeStyles({
    fontSize: 18
});

export const gridFontIconStyles = mergeStyles({
    color: defaultFontColor,
    fontSize: 18
});

export const gridFontIconStylesSmall = mergeStyles({
    color: defaultFontColor,
    fontSize: 12
});

export const homeBrandIconStyles = mergeStyles({
    marginLeft: 2,
    marginRight: 2,
    display: "flex"
});

export const homeFontIconStyles = mergeStyles({
    marginLeft: 2,
    marginRight: 2,
    fontSize: 18,
    display: "flex"
});

export const homeFontIconStylesMedium = mergeStyles({
    marginLeft: 2,
    marginRight: 2,
    fontSize: 16,
    display: "flex"
});

export const iconStyles: IIconStyles = {
    root: {
        color: defaultFontColor
    }
}

export const iconDisplayStyle: IIconStyles = {
    root: {
        display: "flex",
    }
}